import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './sent-emails.action';

@Injectable({ providedIn: 'root' })
export class SentEmailsTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '',
                to_email: '',
                subject: '',
                tries: '',
                status_text: null
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'email_type';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    statuses = [
        {id: "1", name:"SENT_EMAILS.queued"},
        {id: "2", name:"SENT_EMAILS.sent"},
        {id: "3", name:"SENT_EMAILS.failed"},
        {id: "4", name:"SENT_EMAILS.failed-permanently"}
    ];
    hasFilter = false;
    columns = [
                { prop: 'created_at', name: 'SENT_EMAILS.date-time', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'to_email', name: 'SENT_EMAILS.recipient', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'subject', name: 'SENT_EMAILS.subject', sortable: true, hasFilter: true, filter: "input", widthSet: 400},
                { prop: 'tries', name: 'SENT_EMAILS.tries', sortable: true, hasFilter: true, filter: "input", widthSet: 70},
                { prop: 'status_text', name: 'COMMON.status', sortable: false, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name", widthSet: 140},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            created_at: '',
            to_email: '',
            subject: '',
            tries: '',
            status_text: null
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}